const SpeechText = ({ text, forPdf = false }) => {
  if (!text) return null;

  // Split text by [Note: ...] patterns
  const parts = text.split(/(\[Note:\s*[^\]]+\])/g);

  return (
    <div className="whitespace-pre-line">
      {parts.map((part, i) => {
        const noteMatch = part.match(/^\[Note:\s*([^\]]+)\]$/);
        if (noteMatch) {
          if (forPdf) {
            // Simple styled div for PDF rendering (no SVG icons)
            return (
              <span
                key={i}
                className="speech-note-pdf"
                style={{
                  display: 'inline-block',
                  background: '#EFF6FF',
                  border: '1px solid #BFDBFE',
                  color: '#1D4ED8',
                  fontSize: '11px',
                  padding: '4px 10px',
                  borderRadius: '6px',
                  margin: '4px 2px',
                  fontFamily: 'sans-serif',
                  fontStyle: 'normal',
                  lineHeight: '1.4',
                }}
                data-testid="speech-note-pdf"
              >
                {'💬 '}{noteMatch[1]}
              </span>
            );
          }
          return (
            <span
              key={i}
              className="inline-flex items-start gap-1.5 bg-blue-50 border border-blue-200 text-blue-700 text-xs px-2.5 py-1.5 rounded-md my-1 mx-0.5 font-sans not-italic leading-snug"
              data-testid="speech-note"
            >
              <svg className="h-3 w-3 mt-0.5 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/></svg>
              <span>{noteMatch[1]}</span>
            </span>
          );
        }
        return <span key={i}>{part}</span>;
      })}
    </div>
  );
};

export default SpeechText;
